import { render } from "./create-return-btn.vue?vue&type=template&id=6f8bd9ce"
import script from "./create-return-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./create-return-btn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/orders/pages/orders-returns-list/components/create-return-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f8bd9ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f8bd9ce', __exports__)) {
    console.log('reload')
    api.reload('6f8bd9ce', __exports__)
  }
  
  module.hot.accept("./create-return-btn.vue?vue&type=template&id=6f8bd9ce", () => {
    console.log('re-render')
    api.rerender('6f8bd9ce', render)
  })

}


export default __exports__